import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';

import { FsBuildService } from '@firestitch/build';

import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { FsProgressModule } from '@firestitch/progress';
import { AppService, SessionService, WindowMessageService } from './core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FsProgressModule, RouterOutlet],
})
export class AppComponent {
  private _build = inject(FsBuildService);
  private _windowMessageService = inject(WindowMessageService);
  private _appService = inject(AppService);
  private _sessionService = inject(SessionService);
  private _iconRegistry = inject(MatIconRegistry);


  // Timer service injected here to construct service on app init. Don't remove
  // Global Drawer service injected here to construct service on app init. Don't remove
  constructor() {
    this._appService.init();
    this._windowMessageService.init();
    this._sessionService.init();
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

}
